"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var Tree_1 = require("../../components/Tree");
var SmsTree = /** @class */ (function (_super) {
    __extends(SmsTree, _super);
    function SmsTree(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.state = {
            sms: _this.props.sms ? _this.props.sms : [],
            invalidSmsUploaded: false
        };
        return _this;
    }
    SmsTree.prototype.render = function () {
        if (this.state.sms && this.state.sms.length > 0) {
            var smsTree = [];
            for (var _i = 0, _a = this.state.sms; _i < _a.length; _i++) {
                var sms = _a[_i];
                smsTree.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("i", { className: "far fa-comment-dots" }), " ", this.getSmsRecord(sms), (0, jsx_runtime_1.jsx)("br", {})] }) }, sms.id));
            }
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Sms [".concat(this.state.sms.length, "]"), children: smsTree }));
        }
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Sms [0]" }));
    };
    SmsTree.prototype.getSmsRecord = function (sms) {
        if (this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Read_Only"])) {
            var dateTimeString = sms.scheduled !== undefined
                ? "Scheduled: ".concat(SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(sms.scheduled), ", Requested:").concat(SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(sms.requested))
                : "Requested:".concat(SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(sms.requested));
            return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["".concat(sms.msgText), " [".concat(dateTimeString, ", ").concat(sms.phone, "]")] });
        }
        return sms.msgText;
    };
    SmsTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], SmsTree);
    return SmsTree;
}(React.Component));
exports.default = SmsTree;
//# sourceMappingURL=SmsTree.js.map